import React, { useContext, useState, useEffect } from "react";
import TokenHandle from "../../context/TokenHandle";
import { motion, useReducedMotion } from "framer-motion";
import { RangeSlider, useSlider } from "../../components/Range";
import ModalWithdraw from "./ModalWithdraw";
const dashboardTotal_ = [
  {
    name: "Deposit",
    value: 0,
  },
  {
    name: "Withdraw",
    value: 0,
  },
  {
    name: "Earnings",
    value: 0,
  },
  // More people...
];
function InvestNow() {
  const {userData,
    allData,
    invest,
    withdraw,
    reinvestment,
    updateHandle,
    idHandle,
    id,
    solPrice,
    userPlans,
    balanceOf,
    isApprove,
    approveHandle,
    deposit,
    getUserDataDeposit,} = useContext(TokenHandle)
  const shouldReduceMotion = useReducedMotion();
  const childVariants = {
    initial: { opacity: 0, y: shouldReduceMotion ? 0 : 25 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };
  const [amount, setamount] = useState(0)


  const [slider1, slider1Config] = useSlider({
    min: 7,
    max: 30,
    value: 10,
    step: 1,
    label: "Number of Days Deposit:",
  });


  const StakeHandle=async ()=>{   
    
    invest(amount,slider1)
  }
  const withdrawHandle=async ()=>{


    withdraw()

  }

  const aboutData = [
    {
      title:
        "Basic Inflation Rate: for every 24 hours, interest rate increase by 0.5% with no maximum while withdraw time decreases by 0.5 day. Minimum day is 5.",
    },
    {
      title:
        "Minimal Deposits 0.025 BNB, no maximal limit and you can have multiple depostis.",
    },
    {
      title:
        "Reinvest: New and improved, increase your earnings by reinvesting in flexible plans to activate compound interest (reinvestment increases with daily basic ROI).",
    },
    {
      title:
        "Terminate Stake: New and improved, investors can terminate their stakes and get 30% of their fund back while the remaining goes into the pool. (plan 1,2,3, are not allowed to terminate after withdrawing interest).",
    },
    {
      title:
        " Insurance: New and improved, this is a wallet whose purpose is to serve as a backup for the project leader allegiances, capital retribution for the community, giveaways for the community, global fund support",
    },

    // More people...
  ];

  
  return (
    <motion.main
      initial="initial"
      animate="visible"
      variants={{
        initial: { opacity: 0 },
        visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
      }}
      id="dashboard"
      className="pt-32 mx-auto max-w-7xl px-4 sm:pt-40 sm:px-6 lg:pt-48 pb-8"
    >
      <div className="grid grid-cols-2 gap-2 md:grid-cols-1 xl:gap-5 sm:gap-3 mb-8 max-w-7xl mx-auto">
        <div className="col-start-1 col-span-2">
          <div className="rounded-md  w-full h-full transition-all ease-in-out duration-200 shadow-xl relative overflow-hidden bg-white rounded-lg">
          <h1 className=" text-4xl tracking-tight font-extrabold sm:text-5xl text-slate-900 text-center pt-3 mt-8">
          Measure your Harvest

                </h1>
            <div className="grid grid-cols-8 gap-5 items-center px-5 py-2 lg:mt-12">
              
              <div className="col-span-8 pb-4 grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="px-8 mx-auto">
                <h1 className=" text-xl tracking-tight font-extrabold sm:text-2xl text-slate-900 text-center pt-3">
                Deposit Period
                </h1>
                <div className="flex justify-center mt-8">
                    <RangeSlider
                    
                      {...slider1Config}
                      classes="lg:w-[600px] w-60"
                    />
                  </div>
                </div>
              
                <div className="">
                  {/* Stake */}
                
                  {/* Dashboard */}
                  <div className="flex justify-center">
                    <div className="pl-4 pr-6 pt-4 pb-4  sm:pl-6 lg:pl-8 xl:pl-6 xl:pt-6 xl:border-t-0">
                      <div className="flex items-center">
                        <h1 className="flex-1 text-xl tracking-tight font-extrabold sm:text-2xl text-slate-900 text-center">
                          Amount Deposit:
                        </h1>
                      </div>
                      <div className="mt-5 sm:flex sm:items-center">
                        <div className="">
                          <input
                            type="number"
                            name="Deposit"
                            onChange={(e)=>{
                              const value = e.target.value
                              if(value==""||isNaN(value)||value<0)
                              setamount(0.05)
                              else
                              setamount(value)
                            
                            }}
                            className="text-center shadow-sm bg-white ring-1 ring-slate-900/10 hover:ring-slate-300 focus:outline-none focus:ring-2 focus:ring-sky-500 shadow-sm rounded-lg text-slate-800"
                            placeholder="Deposit"
                          />
                        </div>
                        {isApprove?<button
                          onClick={()=>StakeHandle()}
                          className="mt-3 w-full inline-flex items-center justify-center px-4 py-3 border border-transparent shadow-sm font-medium rounded-md bg-yellow-brand  text-slate-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-400 sm:mt-0 sm:ml-3 sm:w-auto sm:text-md"
                        >
                          Stake BUSD
                        </button>
                      :
                      <button onClick={()=>approveHandle()}
                          className="mt-3 w-full inline-flex items-center justify-center px-4 py-3 border border-transparent shadow-sm font-medium rounded-md bg-yellow-brand  text-slate-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-400 sm:mt-0 sm:ml-3 sm:w-auto sm:text-md"
                        >
                          Approve
                        </button>                      
                      }
                      </div>
                      <div className="lg:mt-3 flex justify-center">
                        <ModalWithdraw  onClick={()=>withdrawHandle()} />

                      </div>
                   
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.main>
  );
}

export default InvestNow;
